import authConstants from '../constants';

export default function () {
    return { type: authConstants.QR_SCANNER_DIALOG_OPEN };
}